// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ek1RCTEeGB81RHOw3gGh {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.vlpclaSG7aSNzA2bU4Nj {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 35px 51px 0;
}

.uHNx79SU1cmcW4yM2LUk {
  text-align: center;
  margin-bottom: 20px;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.yFVwf9u39JWv5ULPv9uW {
  font-size: 16px;
  line-height: 21px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  white-space: pre-line;
}

.ViO16bjnZa1TdS3Lhhdg {
  padding: 0;
  margin: 0;
}

.hFNsfGStllsLF5sOqAvs {
  margin: 16px 0;
}

.kZ9E27IJqVTMsdHZwL8r {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/NewActionItemTypesModal/style.modules.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mBAAA;EA1BA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA9CF;;AAwEA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;EACA,qBAAA;AArEF;;AAwEA;EACE,UAAA;EACA,SAAA;AArEF;;AAwEA;EACE,cAAA;AArEF;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AArEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.modalNewAiTypes {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 35px 51px 0;\n}\n\n.modalBodyTitle {\n  text-align: center;\n  margin-bottom: 20px;\n\n  @include modalTitle;\n}\n\n.modalBodyText {\n  font-size: 16px;\n  line-height: 21px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  white-space: pre-line;\n}\n\n.changesList {\n  padding: 0;\n  margin: 0;\n}\n\n.changesListTitle {\n  margin: 16px 0;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalNewAiTypes": `ek1RCTEeGB81RHOw3gGh`,
	"modalBody": `vlpclaSG7aSNzA2bU4Nj`,
	"modalBodyTitle": `uHNx79SU1cmcW4yM2LUk`,
	"modalBodyText": `yFVwf9u39JWv5ULPv9uW`,
	"changesList": `ViO16bjnZa1TdS3Lhhdg`,
	"changesListTitle": `hFNsfGStllsLF5sOqAvs`,
	"modalFooter": `kZ9E27IJqVTMsdHZwL8r`
};
export default ___CSS_LOADER_EXPORT___;
